import React, { useState } from 'react';
import styles from './TextEffectsRetro.module.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

export type TextEffectsRetroProps = TextEffectsSharedProps;

const TextEffectsRetro: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);
  const [animationClass, setAnimationClass] = useState('');

  const getComputedLayerCountClassName = (
    event: React.MouseEvent<Element, MouseEvent>,
  ) => {
    const layerCount = window
      .getComputedStyle(event.currentTarget)
      .getPropertyValue('--layer-count');
    return `colorAnimation${layerCount}`;
  };

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      onMouseEnter={e => {
        const computedLayerCountClassName = getComputedLayerCountClassName(e);
        setAnimationClass(computedLayerCountClassName);
      }}
      onMouseLeave={() => {
        setAnimationClass('');
      }}
      tagProps={{
        animated: true,
        'data-testid': TestIds.viewer.container,
      }}
      data-effect-type="retro"
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={data => ({
          className: cx(styles.wrapper, styles[animationClass]),
          'data-text': data,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <span
            className={cx(styles.text, styles.block)}
            data-testid={TestIds.viewer.text}
          >
            {data}
          </span>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsRetro;
